module.exports = __webpack_public_path__ + "static/media/chat-group-users.6f49b066.svg";